// Direct React imports — the previous react-shim re-export was creating
// two distinct React instances at runtime, which broke React Context
// propagation. AuthProvider rendered via shim's React, but ChatbotList
// imported `useState` from 'react' directly — different module identity
// → different internal context registry → useContext returned default.
// See AuthContext.tsx for full bug history.
import * as React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initSentry } from './lib/sentry'

// Initialize Sentry error monitoring (no-op if VITE_SENTRY_DSN is not set)
initSentry();

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(React.createElement(App));
} else {
  console.error('Root element not found. Cannot mount application.');
}
